import { useEffect, useRef, useState } from "react";
import { api, pesanGalat } from "../../../lib/api";
import { Field, Sheet } from "./Common";

export default function RemoveStockItem({item, warehouse, onClose, onRemoved}) {
  const [preview, setPreview] = useState(null), [reason, setReason] = useState("");
  const [error, setError] = useState(""), [busy, setBusy] = useState(false);
  const lock = useRef(false), path = `/inventory/workspace/items/${item.kind}/${item.id}`;
  useEffect(() => {
    let active = true;
    api.get(`${path}/removal`).then(({data}) => {if (active) setPreview(data);})
      .catch(e => {if (active) setError(pesanGalat(e));});
    return () => {active=false;};
  }, [path]);
  const submit = async e => {
    e.preventDefault();
    if (lock.current || !preview?.allowed || reason.trim().length < 3) return;
    lock.current=true;setBusy(true);setError("");
    try {
      await api.delete(path, {data:{warehouse_id:warehouse,revision:preview.revision,reason:reason.trim()}});
      onRemoved(item);
    } catch (e) {setError(pesanGalat(e));}
    finally {lock.current=false;setBusy(false);}
  };
  return <Sheet title="Hapus barang dari inventory" description="Pembatalan barang yang salah input" onClose={() => {if (!lock.current) onClose();}}>
    <form onSubmit={submit} data-testid="inv-hapus-form" className="space-y-4">
      <div className="eh-soft"><b>{[item.nama,item.variant,item.warna].filter(Boolean).join(" · ")}</b><p>{item.identifier}</p><p>{item.kind === "lot" ? `Seluruh batch aksesori: ${preview?.qty ?? item.qty} pcs` : "1 unit"}</p></div>
      {!preview && !error && <p role="status">Memeriksa stok dan transaksi…</p>}
      {preview?.allowed && <><p>Barang akan dikeluarkan dari stok. Riwayat pembatalan dan hasil USB / SICKW tetap disimpan.</p><Field title="Alasan penghapusan"><textarea required minLength={3} maxLength={500} rows={3} value={reason} onChange={e => setReason(e.target.value)} placeholder="Contoh: salah input unit / batch" disabled={busy}/></Field></>}
      {preview && !preview.allowed && <p role="alert" className="eh-error">{preview.reason}</p>}
      {error && <p role="alert" className="eh-error">{error}</p>}
      <div className="eh-actions"><button type="button" className="eh-btn secondary" disabled={busy} onClick={onClose}>Batal</button>{preview?.allowed && <button className="eh-btn danger" disabled={busy || reason.trim().length < 3} data-testid="inv-hapus-confirm">{busy ? "Menghapus…" : "Ya, hapus barang ini"}</button>}</div>
    </form>
  </Sheet>;
}
